"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var react_toast_notifications_1 = require("react-toast-notifications");
var globalSlice_1 = require("../../features/global/globalSlice");
var ToastMessageHandler = function () {
    var messages = react_redux_1.useSelector(globalSlice_1.useSelectToastMessages);
    var dispatch = react_redux_1.useDispatch();
    var addToast = react_toast_notifications_1.useToasts().addToast;
    react_1.useEffect(function () {
        if (messages && messages.length) {
            messages.forEach(function (message) {
                addToast(message.text, {
                    appearance: message.appearance,
                    autoDismiss: true,
                    autoDismissTimeout: 2000,
                });
            });
            setTimeout(function () { return dispatch(globalSlice_1.clearToastMessages()); });
        }
    }, [messages]);
    return null;
};
exports.default = ToastMessageHandler;
